import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_shipment_create_details",
  "aria-expanded": "true",
  "aria-controls": "kt_shipment_create_details"
}
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = {
  id: "kt_shipment_create_details",
  class: "collapse show"
}
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = {
  disabled: "",
  value: ""
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: ""
}, "return", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: "customer" }, "Customer Shipment", -1)
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "row mb-6" }
const _hoisted_16 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_17 = { class: "required" }
const _hoisted_18 = { class: "col-lg-8 fv-row" }
const _hoisted_19 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "row mb-6" }
const _hoisted_24 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_25 = { class: "required" }
const _hoisted_26 = { class: "col-lg-8 fv-row" }
const _hoisted_27 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "fv-plugins-message-container" }
const _hoisted_30 = { class: "fv-help-block" }
const _hoisted_31 = { class: "form-group row mb-6" }
const _hoisted_32 = { class: "col-lg-4 col-form-label fw-bold fs-6 required" }
const _hoisted_33 = { class: "col-lg-8" }
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = {
  key: 0,
  class: "card-footer d-flex justify-content-end py-6 px-9"
}
const _hoisted_37 = {
  type: "submit",
  id: "kt_shipment_create_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_38 = { class: "indicator-label" }
const _hoisted_39 = { class: "indicator-progress" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('create', 'unsigned-packages'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('shipmentDetails')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitCreate,
            "validation-schema": _ctx.shipmentsSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.translate('type')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "type",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      placeholder: _ctx.translate('type'),
                      modelValue: _ctx.selectedItem,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItem) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.translate('selectType')), 1),
                        _hoisted_11,
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_ErrorMessage, { name: "type" })
                      ])
                    ])
                  ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.translate('office')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "officeId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedOffice,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedOffice) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_19, _toDisplayString(_ctx.translate('selectOffice')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offices, (office) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: office.id,
                            value: office.id
                          }, _toDisplayString(office.titleTranslate), 9, _hoisted_20))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_ErrorMessage, { name: "officeId" })
                      ])
                    ])
                  ])
                ], 512), [
                  [_vShow, _ctx.selectedItem != 'customer']
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("label", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.translate('driver')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "driverId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.driverTitles[0],
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.driverTitles[0]) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_27, _toDisplayString(_ctx.translate('selectDriver')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drivers, (driver) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: driver.id,
                            value: driver.id
                          }, _toDisplayString(driver.fullName), 9, _hoisted_28))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_ErrorMessage, { name: "driverId" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("label", _hoisted_32, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('packages')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "packages",
                        class: "form-control form-control-lg form-control-solid",
                        value: _ctx.packagesArray.length,
                        disabled: ""
                      }, null, 8, ["value"]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_ErrorMessage, { name: "packages" })
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              (!_ctx.createdShipment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createElementVNode("button", {
                      type: "reset",
                      class: "btn btn-white btn-active-light-primary me-2",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                    }, _toDisplayString(_ctx.translate('discard')), 1),
                    _createElementVNode("button", _hoisted_37, [
                      _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.translate('saveChanges')), 1),
                      _createElementVNode("span", _hoisted_39, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_40
                      ])
                    ], 512)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}